import React from 'react'

export default function Horario() {
  return (
    <div id='horario' className='container-fluid g-0 bg-danger pb-5'>
        <div className='container g-0'>
           <h1 className='pt-5'>Horario</h1>
        </div>
        <div className='container'>
            <div className='row m-2 bg-light p-5'>
                <div className='col-lg-4 p-0 m-0 my-auto'>
                    <img className='img-fluid' alt='servicio' src='https://cdn.pixabay.com/photo/2016/11/23/17/22/open-1853924_1280.jpg'/>
                </div>
                <div className='col-lg-8 my-auto'>
                    <p className='lead text-danger fw-bold mt-3'>Horas de servicio</p>
                    <ul class="list-group list-group-flush">
                    <li class="list-group-item text-danger"><span className='text-danger me-3'>Domingo</span>  11a - 6p</li>
                    <li class="list-group-item text-danger"><span className='text-danger me-3'>Lunes</span>  11a - 6p</li>
                    <li class="list-group-item text-danger"><span className='text-danger me-3'>Martes</span>  11a - 6p</li>
                    <li class="list-group-item text-danger"><span className='text-danger me-3'>Miercoles</span>  11a - 6p</li>
                    <li class="list-group-item text-danger"><span className='text-danger me-3'>Jueves</span> Cerrado</li>
                    <li class="list-group-item text-danger"><span className='text-danger me-3'>Viernes</span>  11a - 6p</li>
                    <li class="list-group-item text-danger"><span className='text-danger me-3'>Sabado</span>  11a - 6p</li>
                </ul>
                </div>
            </div>
        </div>
    </div>
  )
}
